import { Icon } from '..';

export const IndicatorIcon: Icon = () => {
  return <span className="text-red-dark">*</span>;
};
